<template>
    <div class="Experimentlist">
            <el-row>
                <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                    <div class="contentl">
                        <p class="tit">
                            探究实验
                        </p>
                        <div class="break" style="font-size:14px;margin-left:20px;margin-bottom:15px;float:left;margin-top:28px;"><span>{{eduName}}</span></div>
                        <!-- <el-radio-group v-model="radio1" class="rowtab2" @change="switcs" v-if="swit">
                            <el-radio-button label="免费" class="buttontab2"></el-radio-button>
                            <el-radio-button label="全部" class="buttontab2"></el-radio-button>
                        </el-radio-group>
                        <el-radio-group v-model="radio1" class="rowtab2" @change="switcs2" v-if="swit2">
                            <el-radio-button label="免费" class="buttontab2"></el-radio-button>
                            <el-radio-button label="全部" class="buttontab2"></el-radio-button>
                        </el-radio-group> -->
                        <ul>
                            <li>
                            <el-input placeholder="输入实验名称进行搜索" clearable v-model="search" @keyup.enter.native="searchto" class="input-with-select" v-if="inpu" @change="closeSearch">
                                    <el-button slot="append" @click="searchto"><i class="magnifier"></i></el-button>
                                    <el-button slot="append" @click="Rescreening" style="border-left:1px solid #DCDFE6;"><i class="refresh"></i></el-button>
                            </el-input>
                            <el-input placeholder="输入实验名称进行搜索" clearable v-model="search" @keyup.enter.native="searchto2" class="input-with-select" v-if="inpu2" @change="closeSearch2">
                                    <el-button slot="append" @click="searchto2"><i class="magnifier"></i></el-button>
                                    <el-button slot="append" @click="Rescreening2" style="border-left:1px solid #DCDFE6;"><i class="refresh"></i></el-button>
                            </el-input>
                            </li>
                        </ul>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin:10px;">
                <el-col :xs="24" :sm="24" :lg="24" :xl="24">
        <!-- <div class="modularBar" style="margin-left:10px;">
            <template>
                <div style="margin-top: 10px;margin-bottom:10px;">
                    <el-radio-group v-model="modularBar" size="small" @change="exModule">
                        <el-radio label="" border>全部</el-radio>
                        <el-radio label="1" border>电学</el-radio>
                        <el-radio label="2" border>力学</el-radio>
                        <el-radio label="3" border>光学</el-radio>
                        <el-radio label="4" border>化学</el-radio>
                    </el-radio-group>
                </div>
            </template>
        </div> -->
                    <div class="list" v-if="itemOk">
                        <div class="noshow" v-if="dataList==''">
                            <span>该分类下暂时没有实验</span>
                            <p><img src="../../assets/images/portal/noex.png" alt=""></p>
                        </div>
                        <el-row :gutter="20">
                            <el-col :xs="12" :sm="8" :lg="8" :xl="8" class="item" v-for="(item,index) in dataList" :key="index" v-loading="loading">
                                <div class="itemIn">
                                    <div class="pic" @click="infoex(item)">
                                        <el-image fit="cover" :src="imageChanges[index] || this.imgage" :alt="item.title" v-loading="loading" :title="item.explanatoryNote">
                                            <div slot="error" class="image-slot">
                                                <img src="../../assets/images/portal/nophoto.png">
                                            </div>
                                        </el-image>
                                        <!-- <img :src="item.fileThumbnail" :alt="item.title" :title="item.explanatoryNote" @error="errorUserPhoto"> -->
                                        <div class="pichover" v-if="false">开始实验</div>
                                        <div class="tbtj" :class="{'box3':item.isStudy == 1}">
                                            <b class="left-top">{{item.isStudy | isStudy}}</b>
                                        </div>
                                        <!-- <div class="box" :class="{'box2':item.collectFees==1}">
                                            <b class="right-top">{{item.collectFees | isCollectFees}}</b>
                                        </div> -->
                                    </div>
                                    <!-- 收藏用小星星 -->
                                    <!-- <div class="collection" @click="toggle(index,item)">
                                        <i class="collectioni" :class="item.collect == true ? star:''"></i>
                                    </div> -->
                                    <h5 class="titl"><i :class="{'isRecomm':item.isRecomm==1}"></i>{{item.title}}</h5>
                                    <div class="pick">
                                        <!-- <p>评分：
                                            <el-rate
                                                v-model="item.average"
                                                disabled
                                                disabled-void-color="#c8c8c8"
                                                >
                                            </el-rate>
                                        </p> -->
                                        <p><i class="el-icon-view" style="margin-right:6px;"></i>浏览量：
                                            <span>{{item.browseNum}}</span>
                                        </p>
                                        <p style="float:right" class="isshow"><el-button class="allEx" size="mini" @click="saveEx(index,item)">收藏到我的实验</el-button></p>
                                        <p style="float:right" class="isshow2"><el-button class="allEx" size="mini" @click="saveEx(index,item)">收藏实验</el-button></p>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <div class="paginations" v-if="pagin">
                            <el-pagination
                                background
                                hide-on-single-page
                                layout="prev, pager, next"
                                :total="pageData.total"
                                @current-change="pageChange"
                                :current-page.sync="page"
                                :page-size='12'
                                >
                            </el-pagination>
                        </div>
                        <div class="paginations" v-if="pagin2">
                            <el-pagination
                                background
                                hide-on-single-page
                                layout="prev, pager, next"
                                :total="pageData.total"
                                @current-change="pageChange2"
                                :current-page.sync="page"
                                :page-size='12'
                                >
                            </el-pagination>
                        </div>
                    </div>
                </el-col>
            </el-row>

        <div class="boxxx" v-if="boxEx">
            <div class="transition-box">
                <div class="head">收藏实验<p @click="closea"><img src="../../assets/images/newimg/close.png" alt=""></p></div>
                <div class="content">
                    <ul>
                        <li>实验名称：<el-input class="Exinput" v-model="ExTitle" placeholder="请输入实验名称"></el-input></li>
                        <li>添加知识点属性：
                                <el-cascader
                                    :options="treeData"
                                    :props="defaultProps"
                                    ref="scalectT"
                                    @change="treeId"
                                    clearable
                                    >
                                </el-cascader>
                        </li>
                        <li>添加章节属性：
                                <el-cascader
                                    :options="chapterData"
                                    :props="defaultProps2"
                                    ref="scalectC"
                                    @change="chapterId"
                                    clearable
                                    >
                                </el-cascader>
                        </li>
                        <li>
                            <el-button :loading="loading" class="joinBtn" type="warning" @click="preserCon">确定</el-button>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request'

export default {
    // props:['src'],
    data(){
        return{
            isTable:'',
            ExTitle:'',
            ExId:'',
            treeIds:[],
            chapterIds:[],
            tre:[],
            cha:[],
            // 知识点请求
            treeData: [],
            defaultProps: {
                value:'id',
                children: 'children',
                label: 'chapterName',
                multiple: true,
                checkStrictly: true
            },
            // 章节请求
            chapterData: [],
            defaultProps2: {
                value:'id',
                children: 'children',
                label: 'chapterName',
                multiple: true,
                checkStrictly: true
            },
            // 实验弹框
            boxEx:false,
            userVIP:'',
            // 实验模块分类栏
            modularBar:"",
            itemOk:false,
            isStudy:'',
            imageChanges:[],
            imgage:'',
            userId:0,
            star:'collection-2',
            // url:'https://i.loli.net/2019/07/31/5d40fc0c0704d86318.png',
            errorUserPhoto:'https://i.loli.net/2019/07/31/5d40ffb611a2f82333.png',
            page:0,
            loading:false,
            radio1:'全部',
            swit:false,
            swit2:false,
            inpu:false,
            inpu2:false,
            pagin:false,
            pagin2:false,
            isfree:'',
            search: '',
            themeType:'',
            materialType:'',
            infoNumber:'',
            // type:'',
            dataList:[{}],
            eduId:'',
            eduName:'',
        pageData:{
            currentPage:1,
            pagesize:12,
            pagenumber:0,
            total:0,
            average:0,
        },
      }
    },
　　filters: {
        isCollectFees: function (value) {
            if(value==0){
                return '免费'
            }else if(value==1){
                return '收费'
            }
        },
        isStudy: function (value) {
            if(value==0){
                return '同步'
            }else if(value==1){
                return '探究'
            }
        },
        isRecomm: function (value) {
            if(value==0){
                return '推荐'
            }else if(value==1){
                return '不推荐'
            }
        },
　　},
    created(){
        this.getinfo();
    },
    methods:{
        getnodeNames(){
            if(this.eduId == ''){
                this.eduId = 0
            }
            request({
                method: 'get',
                url: 'api/user/subject/getnodename?eduid='+this.eduId
            }).then(res=>{
                this.eduName = res.data
            })
        },
        // 清空搜索框-知识点
        closeSearch(val){
            if(val == ''){
                this.searchto();
            }
        },
        // 清空搜索框-章节
        closeSearch2(val){
            if(val == ''){
                this.searchto2();
            }
        },
        // 获取treeId
        treeId(value){
            this.treeIds = []
            for(let trees in value){
                this.treeIds.push(this.$refs.scalectT.getCheckedNodes()[trees].value)
            }
            if(this.treeIds == ''){
                this.treeIds = this.tre
            }
        },
        // 获取chapterId
        chapterId(value){
            this.chapterIds = []
            for(let chapters in value){
                this.chapterIds.push(this.$refs.scalectC.getCheckedNodes()[chapters].value)
            }
            if(this.chapterIds == ''){
                this.chapterIds = this.cha
            }
        },
        // 收藏我的实验
        preserCon(){
            this.loading = true
            request({
                method:'post',
                url:'api/Oauth/GetKey'
            }).then(res=>{
                if(res.code == 400){
                    this.$notify({
                        message: '实验有误，请联系管理员',
                        type: 'error',
                        duration: 1500
                    })
                    this.loading = false
                }else{
                    this.appIDX = res.data.appidx
                    this.strReady = res.data.strread
                    this.titleNameKey = res.data.titlename
                    if(this.appIDX == ''&&this.strReady == ''&&this.titleNameKey == ''){
                        this.$notify({
                            message: '实验有误，请联系管理员，或重试',
                            type: 'error',
                            duration: 1500
                        })
                        this.loading = false
                    }else{
                        request({
                            method:'post',
                            url:'api/resJdsylistinfo?'+'appIDX='+this.appIDX+'&chapterIds='+this.chapterIds+'&strReady='+encodeURIComponent(this.strReady)+'&titleNameKey='+this.titleNameKey+'&treeIds='+this.treeIds+'&userId='+this.userId+'&resourcesId='+this.ExId+'&jdResorcesName='+this.ExTitle,
                        }).then(res=>{
                            if(res.code == 400){
                                this.$notify({
                                    message: '实验有误，请联系管理员，或重试',
                                    type: 'error',
                                    duration: 1500
                                })
                                this.loading = false
                            }else{
                                this.$notify({
                                    message: '收藏成功，可在我的实验中查看',
                                    type: 'success',
                                    duration: 1500
                                })
                                this.boxEx = false;
                                this.loading = false
                            }
                        })
                    }
                    // }else if(this.chapterIds != '' && this.treeIds != ''){
                    //     request({
                    //         method:'post',
                    //         url:'api/resJdsylistinfo?'+'appIDX='+this.appIDX+'&chapterIds='+this.chapterIds+'&strReady='+encodeURIComponent(this.strReady)+'&titleNameKey='+this.titleNameKey+'&treeIds='+this.treeIds+'&userId='+this.userId+'&resourcesId='+this.ExId+'&jdResorcesName='+this.ExTitle,
                    //     }).then(res=>{
                    //         if(res.code == 400){
                    //             this.$notify({
                    //                 message: '实验有误，请联系管理员，或重试',
                    //                 type: 'error'
                    //             })
                    //         }else{
                    //             this.$notify({
                    //                 message: '收藏成功，可在我的实验中查看',
                    //                 type: 'success'
                    //             })
                    //             this.boxEx = false;
                    //         }
                    //     })
                    // }else if(this.chapterIds == '' && this.treeIds == ''){
                    //     request({
                    //         method:'post',
                    //         url:'api/resJdsylistinfo?'+'appIDX='+this.appIDX+'&chapterIds='+this.Chapterid+'&strReady='+encodeURIComponent(this.strReady)+'&titleNameKey='+this.titleNameKey+'&treeIds='+this.Treeid+'&userId='+this.userId+'&resourcesId='+this.ExId+'&jdResorcesName='+this.ExTitle,
                    //     }).then(res=>{
                    //         if(res.code == 400){
                    //             this.$notify({
                    //                 message: '实验有误，请联系管理员，或重试',
                    //                 type: 'error'
                    //             })
                    //         }else{
                    //             this.$notify({
                    //                 message: '收藏成功，可在我的实验中查看',
                    //                 type: 'success'
                    //             })
                    //             this.boxEx = false;
                    //         }
                    //     })
                    // }
                }
            })
        },
        // 收藏我的实验
        saveEx(index,item){
            this.ExTitle = item.title
            this.ExId = item.id
            request({
                method:'get',
                url:'api/jdResources/'+item.id+'?isStudy='+item.isStudy
            }).then(res=>{
                // 获取知识点
                this.treeIds = []
                this.tre = [] 
                for(let i in res.data.Tree){
                    this.treeIds.push(res.data.Tree[i].id)
                    this.tre.push(res.data.Tree[i].id)
                }
                // 获取章节
                this.chapterIds = []
                this.cha = []
                for(let i in res.data.jdchaptertree){
                    this.chapterIds.push(res.data.jdchaptertree[i].id)
                    this.cha.push(res.data.jdchaptertree[i].id)
                }
            })
            if(item.isStudy == 1){
                this.getTrees();
                this.getChapterTrees();
                this.boxEx = true;
            }else{
                this.$notify({
                    message:'请联系管理员或重试',
                    type:'error',
                    duration: 1500
                })
            }
        },
        //获取侧边栏:按知识点
        getTrees(){
            var _this = this;
            _this.loading=true;
            request({
                url: 'api/trees/trees?'+'noderes=0',
                methods: 'get'
            }).then(function(res){
                _this.treeData = res.data;
                _this.loading=false
            })
        },
        //获取侧边栏:章节
        getChapterTrees(){
            var _this = this;
            _this.loading=true;
            request({
                url: 'api/chaptertrees/chaptertrees?'+'noderes=0',
                methods: 'get'
            }).then(function(res){
                _this.chapterData = res.data;
                _this.loading=false
            })
        },
        // 关闭实验框
        closea(){
            this.boxEx = false
            this.eduIdz = 0
            this.eduIdj = 0
            this.nums = 0;
            this.nums2 = 0;
            this.exName = '';
            this.loading = false
        },
        // 实验模块
        exModule(value){
            this.modularBar = value
            if(this.changeNum == 0){
                this.getList3()
            }else if(this.changeNum == 1){
                this.getList()
            }else if(this.changeNum == 2){
                this.getList2()
            }
        },
        // 收藏
        toggle(index,item){
            request({
                method:'post',
                url:'api/updateUserCollect?'+'resourcesId='+item.id+'&userId='+this.userId
            }).then(res=>{
                if(res.data == "收藏成功"){
                    this.dataList[index].collect=!this.dataList[index].collect
                }else{
                    this.dataList[index].collect=!this.dataList[index].collect
                }
            })
        },
        //获取info
        getinfo(){
          request({
            method:'get',
            url:'auth/info'
          }).then(res=>{
            this.userVIP = res.jwtUser.userVIP
            if(res.userSubjectK !== null && res.userSubjectC !== null){
                this.swit = true
                this.swit2 = false
                this.inpu = true
                this.inpu2 = false
                this.pagin = true
                this.pagin2 = false
                this.userId = res.jwtUser.id
                this.eduId = res.userSubjectK.treeId
                this.eduName = res.userSubjectK.nodeNames
                this.infoNumber = 0
                this.getList()
            }else if(res.userSubjectK == null && res.userSubjectC == null){
                this.swit = true
                this.swit2 = false
                this.inpu = true
                this.inpu2 = false
                this.pagin = true
                this.pagin2 = false
                this.userId = res.jwtUser.id
                this.infoNumber = 0
                this.getList()
            }else if(res.userSubjectK !== null){
                this.swit = true
                this.swit2 = false
                this.inpu = true
                this.inpu2 = false
                this.pagin = true
                this.pagin2 = false
                this.userId = res.jwtUser.id
                this.eduId = res.userSubjectK.treeId
                this.eduName = res.userSubjectK.nodeNames
                this.infoNumber = 0
                this.getList()
            }else if(res.userSubjectC !== null){
                this.swit = false
                this.swit2 = true
                this.inpu = false
                this.inpu2 = true
                this.pagin = false
                this.pagin2 = true
                this.userId = res.jwtUser.id
                this.eduId = res.userSubjectC.treeId
                this.eduName = res.userSubjectC.nodeNames
                this.infoNumber = 1
                this.getList2()
            }
            this.getProp()
          })
        },
        //按知识点
        Rescreening(){
            this.$confirm('您是否要重置搜索内容？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnT',
            type: 'warning',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.currentPage = 1;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList()
            }).catch(() => {      
            });
        },
        // 按章节
        Rescreening2(){
            this.$confirm('您是否要重置搜索内容？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnT',
            type: 'warning',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.currentPage = 1;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList2()
            }).catch(() => {      
            });
        },
        //按知识点
        searchto(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$notify({
                        message:"此为非法字符，请确认后输入",
                        type:'error',
                        duration: 1500
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList();
        },
        //按章节
        searchto2(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$notify({
                        message:"此为非法字符，请确认后输入",
                        type:'error',
                        duration: 1500
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList2();
        },
        //按知识点搜索
        switcs(value){
          if(value == "全部"){
              this.isfree = ''
          }else{
              this.isfree = 0
          }
          this.pageData.total = 0;
          this.pageData.pagenumber = 0;
          this.getList()
        },
        //按章节搜索
        switcs2(value){
          if(value == "全部"){
              this.isfree = ''
          }else{
              this.isfree = 0
          }
          this.pageData.total = 0;
          this.pageData.pagenumber = 0;
          this.getList2()
        },
        infoex(item){
            if(item.collectFees == 1){
                this.$notify({
                message:'对不起，您还没有购买过此实验，请先购买，或联系销售人员',
                type:'error',
                duration: 1500
              })
            }else{
                this.$router.push({
                path: "/TJinfoE",
                query: {
                    infoId:item.id,
                    // infoTitle:item.title,
                    // infoPhoto:item.fileThumbnail,
                    infoBrowseNum:item.browseNum,
                    // infoAerage:item.average,
                    // infoScoringMan:item.scoringMan,
                    // infoTotalPoints:item.totalPoints,
                    infoNumber:this.infoNumber,
                    infoTreeId:this.eduId,
                    infoMb:this.userVIP,
                    infoNodeName:this.eduName,
                    infoIsFree:this.isfree,
                    infoSearch:this.search,
                    infoStudy:item.isStudy,
                    infoisStudy:this.isStudy,
                    }
                });
                // window.open(routeUrl .href, '_blank');
            }
        },
        offAllListen(){
            this.bus.$off("switcE")
            this.bus.$off("switcE2")
            this.bus.$off("ificationE")
            this.bus.$off("ificationE2")
            this.bus.$off("ificationE3")
        },
        // 传参
        getProp(){
            // 标签
            // this.bus.$on("myFun1",prop=>{
            // this.themeType = prop;
            // this.getList()
            // })
            //特色实验
            // this.bus.$on("myFun2",prop=>{
            // this.materialType = prop;
            // this.getList()
            // })
            this.bus.$on("switcE",prop=>{
                if(prop == 0){
                    this.eduId = '';
                }else{
                    this.eduId = prop;
                }
                this.eduName = '';
                this.pageData.total = 0;
                this.pageData.pagenumber = 0;
                this.infoNumber = 0
                this.getList()
                this.getnodeNames();
            })
            this.bus.$on("switcE2",prop=>{
                if(prop == 0){
                    this.eduId = '';
                }else{
                    this.eduId = prop;
                }
                this.eduName = '';
                this.pageData.total = 0;
                this.pageData.pagenumber = 0;
                this.infoNumber = 1
                this.getList2()
                this.getnodeNames();
            })
            //按知识点
            this.bus.$on("ificationE",prop=>{
                this.eduId = prop.id;
                this.eduName = prop.nodename
                this.pageData.pagenumber = 0;
                this.page = 1;
                this.pagin = true;
                this.pagin2 = false;
                this.getList()
            })
            //按章节
            this.bus.$on("ificationE2",prop=>{
                this.eduId = prop.id;
                this.eduName = prop.nodename
                this.pageData.pagenumber = 0;
                this.page = 1;
                this.pagin = false;
                this.pagin2 = true;
                this.getList2()
            })
            //按章节
            this.bus.$on("ificationE3",prop=>{
                this.eduId = prop.id;
                this.eduName = prop.nodename
                this.pageData.pagenumber = 0;
                this.page = 1;
                this.pagin = true;
                this.pagin2 = false;
                this.getList()
            })
        },
        //通过知识点获取
        getList(type){
            this.bus.$emit("knowledgeEx", 1)
            this.inpu = true
            this.inpu2 = false
            this.swit = true
            this.swit2 = false
            this.pagin = true
            this.pagin2 = false
            this.loading = true
            request({
                 method:'get',
                 url: 'api/trees?'+'eduTreeIds='+this.eduId+'&page='+this.pageData.pagenumber+'&size='+this.pageData.pagesize+'&themeType='+this.themeType+'&materialType='+this.materialType+'&collectFees='+this.isfree+'&title='+this.search+'&shelves=1'+'&noderes=1'+'&sort=stick%2Cdesc'+'&userId='+this.userId+'&isStudy=1'+'&userCollect=0'+'&modularBar='+this.modularBar
            }).then(res=>{
                this.dataList = res.data.content;
                let changeimg = res.data.content;
                this.imageChanges = [];
                for(let i in changeimg){
                    if(changeimg[i].fileThumbnail == null){
                        this.imageChanges.push(changeimg[i].fileThumbnail)
                    }else{
                        this.imageChanges.push((changeimg[i].fileThumbnail.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }
                }
                var temp = {}
                temp.pagesize=this.pageData.pagesize;
                temp.pagenumber=this.pageData.pagenumber;
                temp.total =Number(res.data.totalElements);
                this.pageData=temp
                this.loading = false
                this.itemOk = true
                // 滚动到顶部
                let currentPosition,timer;
                let speed=30;
                setTimeout(() => {
                    timer=setInterval(function(){
                        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
                        currentPosition-=speed;
                        if(currentPosition>0){
                            window.scrollTo(0,currentPosition);
                        }else{
                            window.scrollTo(0,0);
                            clearInterval(timer);
                        }
                    },1);
                }, 100)

            })
        },
        //通过章节获取
        getList2(type){
            this.bus.$emit("chapterEx", 2)
            this.inpu = false
            this.inpu2 = true
            this.swit = false
            this.swit2 = true
            this.pagin = false
            this.pagin2 = true
            this.loading = true
            request({
                 method:'get',
                 url: 'api/chaptertrees?'+'eduTreeIds='+this.eduId+'&page='+this.pageData.pagenumber+'&size='+this.pageData.pagesize+'&themeType='+this.themeType+'&materialType='+this.materialType+'&collectFees='+this.isfree+'&title='+this.search+'&shelves=1'+'&noderes=1'+'&sort=stick%2Cdesc'+'&userId='+this.userId+'&isStudy=1'+'&userCollect=0'+'&modularBar='+this.modularBar
            }).then(res=>{
                this.dataList = res.data.content;
                let changeimg = res.data.content;
                this.imageChanges = [];
                for(let i in changeimg){
                    if(changeimg[i].fileThumbnail == null){
                        this.imageChanges.push(changeimg[i].fileThumbnail)
                    }else{
                        this.imageChanges.push((changeimg[i].fileThumbnail.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }
                }
                var temp = {}
                temp.pagesize=this.pageData.pagesize;
                temp.pagenumber=this.pageData.pagenumber;
                temp.total =Number(res.data.totalElements);
                this.pageData=temp
                this.loading = false
                this.itemOk = true
                // 滚动到顶部
                let currentPosition,timer;
                let speed=30;
                setTimeout(() => {
                    timer=setInterval(function(){
                        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
                        currentPosition-=speed;
                        if(currentPosition>0){
                            window.scrollTo(0,currentPosition);
                        }else{
                            window.scrollTo(0,0);
                            clearInterval(timer);
                        }
                    },1);
                }, 100)
                
            })
        },
        pageChange(data){
            this.pageData.pagenumber = data-1;
            this.getList()
        },
        pageChange2(data){
            this.pageData.pagenumber = data-1;
            this.getList2()
        },
    }
    
}
</script>

<style scoped>
    @import '../styles/search.css';
    @import '../styles/box.css';
    @import '../styles/pad.css';
.Experimentlist{
    width: 100%;height: 100%;background: #fff;
    float:left;
}
.contentl{
    width:98%;
    border-bottom: 1px solid #eee;
    height: 65px;
    margin-left: 1%;
    margin-bottom: 10px;
}
.tit{
    margin: 0;
    line-height: 65px;
    font-size: 20px;
    font-weight: 400;
    float: left;
    color: #333;
}
.rowtab2{
    float: left;
    font-size: 14px;
    margin-top: 32px;
    margin-left: 805px;
}
.buttontab2{
    height: 14px;
    padding-right: 10px;
    border-right: 1px solid #ccc;
}
.buttontab2:last-of-type{
    padding-left: 5px;
    border-right: none;
    padding-right: 0;
}
.contentl>ul{
    height: 65px;
    line-height: 65px;
    margin: 0;
    padding: 0;
    list-style: none;
    padding: 0 126px;
    float: right;
}
.contentl>ul>li{
    width: auto;
    float: left;
    margin: 0;
    padding: 0;
    list-style: none;
}
.list{
    width: 100%;
    height: 100%;
    float:left;
}
.item{
    /* width:30%; */
    float: left;
    margin-bottom: 20px;
    z-index: 10;
}
.itemIn{
    width:100%;
    float: left;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.itemIn:hover{
    transition: all 0.2s linear 0s;
    transform: scale(1.01);
    box-shadow: 4px 7px 18px 0px rgba(0, 0, 0, 0.2);
}
.itemIn:hover .collection{
    display: block;
}
.pic{
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    height:calc( (23.1vw / 16) * 9);
}
.pic /deep/ .el-image{
    width:100%;
    height: 100%;
    float:left;
}
.pic img{
    width:100%;
    height: 100%;
}
/* 同步 探究 */
.tbtj{
    width: 14%;
    height: 30px;
    line-height: 30px;
    background-color: #2174ff;
    border-radius: 2px;
    position: absolute;
    left: 3%;
    top: 5%;
    color: #E8E8E8;
    font-size: 18px;
}
.left-top{
    font-weight: 400;
}
/* 收藏 */
.collection{
    width: 12%;
    height: 14.5%;
    position: absolute;
    right: 3%;
    top: 5%;
    background: #fff;
    padding: 8px;
    border-radius: 4px;
    display: none;
    cursor: pointer;
}
.list /deep/ .image-slot{
    width:100%;
    height:100%;
    float: left;
}
.collection-2{
    width: 100%;
    height: 100%;
    background-image: url(../../assets/images/portal/collection2.png) !important;
    background-size: 100%;
    animation: spin 0.5s ease-in-out;
}
@keyframes spin {
                0%{
                    transform: scale(1);  /*开始为原始大小*/
                }
                100% {
                    transform: scale(1.1);
                }
            }
.collection>i{
    float: left;
    width: 100%;
    height: 100%;
}
.collectioni{
    width: 100%;
    height: 100%;
    background-image: url(../../assets/images/portal/collection.png);
    background-size: 100%;
}
.box3{
    background-color: #00A0E9;
}
/* 收费 免费 */
.box{
    width: 0;
    height: 0;
    border-top: 60px solid  #46b8da;
    border-left: 60px solid transparent;
    margin-bottom: -100px;
    position: absolute;
    right: 0;
    top: 0;
    float: right !important;
    box-sizing: border-box;
    z-index: 200;
}
.box2{
    border-top: 60px solid  #2174ff;
}
.right-top{
    width: 60px;
    font-weight: 600;
    color: #fff;
    position: relative;
    right: 50px;
    top: -50px;
    display: block;
    box-sizing: border-box;
    /* transform: rotate(80deg); */
    -webkit-transform:rotate(45deg)
}
/* .pic:hover .pichover{
    display: block;
    align-items:center;
    display: -webkit-flex;
    justify-content:center;
    cursor: pointer;
}
.pichover{
    width: 100%;
    height: 100%;
    font-size: 22px;
    font-weight: 600;
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    opacity: 0.8;
    display: none;
    transform: all 0.7s;
} */

.titl{
    padding-top: 4%;
    padding-left: 2%;
    font-size: 18px;
    color: #333;
    font-weight: 400;
    width: 94%;
    margin: 0;
    white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;
}
.el-rate{
    float: right;
    color:rgb(236, 111, 40)
}
.paginations{
    width: 100%;
    float: left;
    padding: 18px 20px;
}
.el-pagination{
    text-align: center;
    font-weight: 400;
}
/* 提示信息 */
.noshow{
    height: auto;
    text-align: center;
    margin-top: 166px;
}
.noshow>span{
    font-size: 32px;
    color: #999;
}
.noshow>p{
    margin-top: 69px;
    margin-bottom: 158px;
    width: 593px;
    height: 349px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}
.noshow>p>img{
    width: 100%;
    height: 100%;
}
.isRecomm{
    width: 18px;
    height: 20px;
    float: left;
    margin-right: 9px;
    background-image: url(../../assets/images/portal/hot.png);
    background-size: 100%;
}
.image-slot{
    width: 100%;
    height: 100%;
    float: left;
}
.isshow2{
    display: none;
}
.isshow{
    display: block;
}
  @media (max-width: 1024px){
      .isshow2{
          display: block;
          padding-bottom: 0 !important;
      }
      .isshow{
          display: none;
      }
  }
  @media screen and (min-width:1025px) and (max-width:1366px){
    .break{
        display:none;
    }
    .rowtab2{
        float: left;
        margin-left: 20px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1367px) and (max-width:1440px){
    .rowtab2{
        position: absolute;
        left: 200px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 710px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
    .rowtab2{
        position: absolute;
        left: 200px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 860px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 117px;
    }
    .noshow>span{
        font-size: 26px;
        color: #999;
    }
    .noshow>p{
        margin-top: 55px;
        margin-bottom: 96px;
        width: 474px;
        height: 279px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .rowtab2{
        position: absolute;
        left: 600px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 805px;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 166px;
    }
    .noshow>span{
        font-size: 32px;
        color: #999;
    }
    .noshow>p{
        margin-top: 69px;
        margin-bottom: 158px;
        width: 593px;
        height: 349px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 182px;
    }
    .noshow>span{
        font-size: 34px;
        color: #999;
    }
    .noshow>p{
        margin-top: 74px;
        margin-bottom: 122px;
        width: 633px;
        height: 372px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media (min-width:2049px){
    .paginations{
        padding: 40px 0;
    }
    .rowtab2{
        position: absolute;
        left: 1150px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 805px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 248px;
    }
    .noshow>span{
        font-size: 44px;
        color: #999;
    }
    .noshow>p{
        margin-top: 92px;
        margin-bottom: 246px;
        width: 791px;
        height: 465px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#2174ff;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #2174ff;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #2174ff;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
    [v-cloak] {
        display: none;
    }
</style>

<style rel="stylesheet/scss" lang="scss">
    .messageBox-prompt-test .el-button--primary{
        background-color:#2174ff;
        border-color:#2174ff;
    }
    .messageBox-prompt-test .el-button--default:hover{
        background-color:rgba($color: #2174ff, $alpha: 0.2);
        border-color:rgba($color: #2174ff, $alpha: 0.2);
        color: #2174ff;
    }
</style>


// WEBPACK FOOTER //
// src/components/myComponentsE/shiyanListE.vue